import { Component } from '@angular/core';
import Swal from 'sweetalert2';
import {
  DashboardAddClient,
  NewDebtor,
} from '../../factoring/interface/data.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CompaniesFactoringService } from '../../factoring/services/companies-factoring.service';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';

@Component({
  selector: 'app-add-debtor-modal',
  templateUrl: './add-debtor-modal.component.html',
  styleUrls: ['./add-debtor-modal.component.scss'],
})
export class AddDebtorModalComponent {
  public isMinuteCreate: boolean = false;
  public rutForm: string;
  public cargandoBtn: boolean = false;
  public validateRutSii: boolean = false;
  public userRut: number = 0;

  public form = new FormGroup({
    clientRut: new FormControl<string | ''>('', [Validators.required]),
    siiPass: new FormControl<string | ''>(''),
  });

  constructor(
    public dialogRef: MatDialogRef<AddDebtorModalComponent>,
    private configuracionRut: ConfigRutService,
    private service: CompaniesFactoringService,
    private serviceCompany: CompaniesFactoringService,
    private router: Router,
    private auth: AuthService
  ) {}

  cerrarDialogo() {
    this.dialogRef.close();
  }

  inputRut(event) {
    const { formattedRut, validation } = this.configuracionRut.changeRut(event);
    this.form.controls['clientRut'].setValue(formattedRut);
    if (!validation) {
      this.form.controls['clientRut'].setErrors({
        invalidRut: false,
      });
    }
    this.rutForm = formattedRut;
  }

  get fc() {
    return this.form.controls;
  }

  submit() {
    this.cargandoBtn = true;
    const requestBody: DashboardAddClient = {
      companyRut: this.rutForm,
      siiPassword: this.form.value.siiPass,
      typeCompany: 'isDebtor',
    };
    const rut = this.configuracionRut.transformStringRut(this.rutForm);
    this.userRut = this.configuracionRut.transformStringRut(this.rutForm);
    let timerInterval: any;

    Swal.fire({
      title: 'Registrando Deudor',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.service.addNewCompanies(requestBody).subscribe({
          next: (e) => {
            if (requestBody.siiPassword) {
              timerInterval = setInterval(() => {
                this.validateSii(timerInterval);
              }, 15000);
              this.validateRutSii = true;
              this.dialogRef.close(this.isMinuteCreate);
            } else {
              if (e.validate == 1) {
                this.dialogRef.close(this.isMinuteCreate);
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.userRut}`
                );
              }

              Swal.fire({
                title: e.message,
                icon: 'success',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.dialogRef.close(this.isMinuteCreate);
                  this.router.navigateByUrl(
                    `/dashboards/files-clients?client=${this.userRut}`
                  );
                  this.validateRutSii = true;
                  this.isMinuteCreate = true;
                }
              });
            }
          },
          error: (error) => {
            if (error.status == 404) {
              console.log(error);
              Swal.fire({
                title: error.error.message,
                text: 'No fue posible añadir al deudor',
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: `Ir a perfil`,
              }).then(() => {
                this.dialogRef.close(this.isMinuteCreate);
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${rut}`
                );
              });
            } else {
              Swal.fire({
                title: error.error,
                text: 'No fue posible añadir al deudor',
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: `Cerrar`,
              });
            }
          },
        });
      },
    });
  }

  validateSii(timerInterval: any) {
    let result;
    console.log(timerInterval);
    this.auth.validationStatus(this.userRut).subscribe({
      next: (res) => {
        console.log(res);
        switch (res.content) {
          case 'Failed':
            console.log('failed');
            clearInterval(timerInterval);
            Swal.update({
              title: 'Cliente Registrado',
              icon: 'warning',
              text: 'Pero la clave tributaria es incorrecta',
              confirmButtonText: `Ir a perfil`,
              didClose: () => {
                this.validateRutSii = false;
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.userRut}`
                );
              },
            });
            Swal.hideLoading();

            break;
          case 'Succeed':
            clearInterval(timerInterval);
            Swal.update({
              icon: 'success',
              text: 'Clave tributaria correcta, Registro Realizado',
              confirmButtonText: `Ir a perfil`,
              didClose: () => {
                this.validateRutSii = false;
                this.router.navigateByUrl(
                  `/dashboards/files-clients?client=${this.userRut}`
                );
              },
            });
            break;
          default:
            break;
        }
        res.content;
      },
    });
    return result;
  }
}
